import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  ManageAssignCompanyFormSchemaOptions,
  ManageCompanyFieldsTypes,
  ManageSingleCompanyFormSchemaOptions,
  manageAssignCompanyFormSchema,
  manageSingleCompanyFormSchema,
} from '../../../../../schemas/template-assignment-schema';

export type ManageAction = 'manage' | 'assign';
export function useManageCompanyFormMethods(
  defaultValues?: Partial<ManageCompanyFieldsTypes>,
  action: ManageAction = 'manage',
  options: ManageSingleCompanyFormSchemaOptions & ManageAssignCompanyFormSchemaOptions = {}
) {
  const schema =
    action === 'manage' ? manageSingleCompanyFormSchema(options) : manageAssignCompanyFormSchema(options);
  const defaults = defaultValues ?? schema.getDefault();

  const methods = useForm<ManageCompanyFieldsTypes>({
    defaultValues: defaults,
    resolver: yupResolver(schema),
    mode: 'all',
  });

  return methods;
}
